// extracted by mini-css-extract-plugin
export default {"typing-indicator":"TypingIndicator_typing-indicator__SskG5","dot":"TypingIndicator_dot__iGCew","blink":"TypingIndicator_blink__qc+lb"};